import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import ReactTable from 'react-table'
import { Form, Icon, message, Tooltip } from 'antd'
import Loader from '../../common/Loader'
import { actions as materialRequestActions } from '../../../redux/modules/jobFunctions/jobSiteMaterialRequestActions'
import { actions as materialRequestTemplatesActions } from '../../../redux/modules/jobFunctions/materialRequestTemplatesActions'
import { actions as itemActions } from '../../../redux/modules/jobFunctions/itemActions'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import { arrayMove, filterCaseInsensitive, getModalId } from '../../../util'
import history from '../../../history'
import _ from 'lodash'
import { Modal as ModalRouter } from 'react-router-modal'
import JobSiteMaterialRequestModal from './JobSiteMaterialRequestModal'

class JobSiteMaterialRequests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      requestItems: [],
      currentRevisionNumberPrint: 1
    }
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  componentDidMount() {
    this.props.materialRequestRefresh({
      jobId: this.props.match.params.jobId,
      next: payload => {
        this.setState({
          contentData:
            payload.data && payload.data.find(d => String(d.id) === String(this.state.currentId))
        })
        this.props.getAllItems()
        this.props.getMaterialRequestTemplates()
        console.log('calling next')
        if (this.state.currentId !== 0) {
          this.props.getAuditRevisions({
            targetId: this.state.currentId,
            table: 'material_request'
          })
          console.log('getting material items')
          this.props.getMaterialItems({
            materialRequestId: this.state.currentId
          })
          this.props.getAttachments({
            materialRequestId: this.state.currentId
          })
        }
      }
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.jobSiteMaterialRequestActions.jobSiteMaterialRequests !==
        prevProps.jobSiteMaterialRequestActions.jobSiteMaterialRequests
    ) {
      const highLightEstimate = _.filter(
        this.props.jobSiteMaterialRequestActions.jobSiteMaterialRequests.data,
        estimate => estimate.id === parseInt(this.props.shortcutItemId, 10)
      )
      this.handleRowClick(highLightEstimate[0])
      this.props.clearHighlight()
    }

    if (
      prevProps.materialRequestTemplatesActions.materialRequestTemplateItems !==
      this.props.materialRequestTemplatesActions.materialRequestTemplateItems
    ) {
      this.setState({
        requestItems: this.props.materialRequestTemplatesActions.materialRequestTemplateItems.data
      })
    }

    if (
      prevProps.jobSiteMaterialRequestActions.materialItems !==
      this.props.jobSiteMaterialRequestActions.materialItems
    ) {
      this.setState({
        requestItems: this.props.jobSiteMaterialRequestActions.materialItems.data
      })
    }

    // update the current version for printing
    if (prevProps.auditActions.loading !== this.props.auditActions.loading) {
      const revisions = _.get(this.props, 'auditActions.revisions.data')
      if (revisions && revisions.length > 0) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].revision
        })
      }
    }
  }

  handleRowClick = row => {
    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'material_request'
    })
    this.props.getMaterialItems({
      materialRequestId: row.id
    })
    this.props.getAttachments({
      materialRequestId: row.id
    })
    this.setState(
      {
        currentId: row.id,
        contentData: row
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/material-requests/modal/${row.id}`)
      }
    )
  }

  handleAddButton = () => {
    this.setState(
      {
        currentId: 0,
        contentData: null,
        requestItems: []
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/material-requests/modal/0`)
        this.forceUpdate()
      }
    )
  }

  redirectToMaterialRequests = () => {
    const { jobType, jobId } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/material-requests`)
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, requestItems: [] }, this.redirectToMaterialRequests)
  }

  getSelectedTemplate = value => {
    const materialRequestTemplates = _.get(
      this.props,
      'materialRequestTemplatesActions.materialRequestTemplates.data'
    )
    const selectedTemplate = materialRequestTemplates.find(template => template.name === value)
    return selectedTemplate ? +selectedTemplate.id : +value
  }

  handleCreate = () => {
    const form = this.props.form
    const self = this
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      Object.keys(values).forEach(function(key, value) {
        if (key === 'completed') {
          if (values[key] === 1) {
            if (self.state.contentData.completed === 0) {
              values.completed_date = moment().format('YYYY-MM-DD hh:mm:ss')
            }
            values.status = 'completed'
          } else {
            values.status = 'created'
          }
        }
      })

      values.material_request_template_id = this.getSelectedTemplate(
        values.material_request_template_id
      )

      if (this.state.currentId === 0) {
        this.props.createMaterialRequest({
          jobId: this.props.match.params.jobId,
          content: values,
          requestItems: this.state.requestItems,
          userId: this.props.user.userId
        })
      } else {
        const requestItems = (this.state.requestItems || []).map(item => {
          const allItems =
            this.props.itemActions &&
            this.props.itemActions.allItems &&
            this.props.itemActions.allItems.data
          if (!item.name) {
            const foundItem = allItems.find(it => it.id === +item.item_id || item.id) || {
              name: ''
            }
            return { ...item, name: foundItem.name }
          }
          return { ...item }
        })
        this.props.updateMaterialRequest({
          jobId: this.props.match.params.jobId,
          materialRequestId: this.state.currentId,
          content: values,
          requestItems: requestItems,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState(
        { contentData: null, currentId: 0, requestItems: [] },
        this.redirectToMaterialRequests
      )
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteMaterialRequest({
      jobId: this.props.match.params.jobId,
      materialRequestId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState(
      {
        contentData: null,
        currentId: 0,
        requestItems: []
      },
      this.redirectToMaterialRequests
    )
  }

  addItem = () => {
    const itemsArray = [...this.state.requestItems]
    itemsArray.push({
      name: '',
      quantity: 0,
      notes: '',
      quantityDelivered: 0
    })
    this.setState({
      requestItems: itemsArray
    })
  }

  deleteItem = index => {
    const itemsArray = this.state.requestItems
    itemsArray.splice(index, 1)
    this.setState({
      requestItems: itemsArray
    })
  }

  moveUp = index => {
    this.setState({
      requestItems: arrayMove(this.state.requestItems, index, index - 1)
    })
  }

  moveDown = index => {
    this.setState({
      requestItems: arrayMove(this.state.requestItems, index, index + 1)
    })
  }

  onItemChange = (field, value, index) => {
    const itemArray = this.state.requestItems
    itemArray[index][field] = value
    this.setState({
      requestItems: itemArray
    })
  }

  handleTemplateChange = event => {
    const form = this.props.form
    const selectedTemplate = this.props.materialRequestTemplatesActions.materialRequestTemplates.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedTemplate.length > 0) {
      this.props.getMaterialRequestTemplateItems(selectedTemplate[0].id)
      form.setFieldsValue({
        description: selectedTemplate[0].description
      })
    }
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'material_request')
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('materialRequestId', this.state.currentId)

    this.props.uploadAttachment({
      formData: formData,
      materialRequestId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      materialRequestId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      materialRequestId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }
  handleRevisionChange = value => {
    const form = this.props.form
    const revisionsObject = this.props.auditActions.revisions.data.find(x => x.id === value)
    const revisions = JSON.parse(revisionsObject.json_patch)
    const revisionNumber = revisionsObject.revision

    // set revision numner for printing
    this.setState({
      currentRevisionNumberPrint: revisionNumber
    })

    let changes = {}
    revisions.forEach(revision => {
      const fieldName = revision.path.substring(1, revision.path.length)

      if (fieldName === 'request_items') {
        this.setState(prevState => {
          const requestItems = JSON.parse(revision.value)
          return { ...prevState, requestItems }
        })
      }
      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        changes[fieldName] = Number.isInteger(revision.value) ? +revision.value : revision.value
      }
    })

    form.setFieldsValue(changes)
  }
  getMaterialRequestTemplateName = templateId => {
    const materialRequestsTemplates =
      (this.props.materialRequestTemplatesActions &&
        this.props.materialRequestTemplatesActions.materialRequestTemplates &&
        this.props.materialRequestTemplatesActions.materialRequestTemplates.data) ||
      []
    const template = materialRequestsTemplates.find(template => template.id === templateId)
    if (template) {
      return template.name
    }
  }
  render() {
    const { contentData, currentRevisionNumberPrint } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form
    if (!this.props.jobSiteMaterialRequestActions.jobSiteMaterialRequests) {
      return <Loader />
    }

    const allItems = _.get(this.props, 'itemActions.allItems.data')

    const revisions =
      this.props.auditActions &&
      this.props.auditActions.revisions &&
      this.props.auditActions.revisions.data

    const loadingRevision = this.props.auditActions && this.props.auditActions.loading

    return (
      <div>
        {this.shouldRenderModal() && (
          <ModalRouter
            path="/job/:jobId/:jobType/material-requests/edit/:id"
            exact
            component={JobSiteMaterialRequestModal}
            props={{
              loadingRevision,
              contentData,
              currentRevisionNumberPrint,
              uploadProps,
              getFieldDecorator,
              revisions,
              handleSelectedTemplate: this.handleSelectedTemplate,
              handleCancel: this.handleCancel,
              handleCreate: this.handleCreate,
              materialRequestTemplatesActions: this.props.materialRequestTemplatesActions,
              handleTemplateChange: this.handleTemplateChange,
              handleRevisionChange: this.handleRevisionChange,
              attachmentDetailsVisible: this.state.attachmentDetailsVisible,
              confirmDelete: this.confirmDelete,
              cancelDelete: this.cancelDelete,
              attachmentName: this.state.attachmentName,
              attachmentDescription: this.state.attachmentDescription,
              onDescriptionChange: this.onDescriptionChange,
              handleUpdateAttachmentDescription: this.handleUpdateAttachmentDescription,
              confirmAttachmentDelete: this.confirmAttachmentDelete,
              currentId: this.state.currentId,
              handleAttachmentRowClick: this.handleAttachmentRowClick,
              uploadAttachment: this.uploadAttachment,
              allItems,
              getMaterialRequestTemplateName: this.getMaterialRequestTemplateName,
              getAllItems: this.props.getAllItems,
              jobSiteMaterialRequestActions: this.props.jobSiteMaterialRequestActions,
              requestItems: this.state.requestItems,
              deleteItem: this.deleteItem,
              moveUp: this.moveUp,
              moveDown: this.moveDown,
              addItem: this.addItem,
              addItem2: this.addItem,
              saveRequestItems: this.saveRequestItems,
              onItemChange: this.onItemChange
            }}
          />
        )}
        <div className="jobsBar">
          Material Requests
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Material Request
            </div>
          </div>
        </div>
        {this.props.jobSiteMaterialRequestActions.jobSiteMaterialRequests && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteMaterialRequestActions.jobSiteMaterialRequests.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Completed',
                    className: 'textAlignCenter',
                    Cell: row => {
                      if (row.original.completed === 0) {
                        return <Icon type="close-circle" />
                      }
                      if (row.original.completed === 1) {
                        return <Icon type="check-circle-o" />
                      }
                    },
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Number',
                    accessor: 'number',
                    className: 'textAlignCenter',
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 160
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 160
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Completed Date',
                    id: 'completed_date',
                    accessor: d => {
                      if (moment(d.completed_date).isValid()) {
                        return moment(d.completed_date, 'YYYY-MM-DD hh:mm:ss').format(
                          'M/D/YYYY h:mm:ssa'
                        )
                      } else {
                        return 'Not yet complete'
                      }
                    },
                    maxWidth: 200
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (
  {
    jobSiteMaterialRequestActions,
    itemActions,
    materialRequestTemplatesActions,
    auditActions,
    authentication
  },
  ownProps
) => ({
  jobSiteMaterialRequestActions,
  materialRequestTemplatesActions,
  itemActions,
  auditActions,
  user: authentication.user
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      itemActions,
      materialRequestActions,
      materialRequestTemplatesActions,
      auditActions
    ),
    dispatch
  )
})

const propTypes = {}

JobSiteMaterialRequests.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteMaterialRequests))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteMaterialRequests.js